import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          分类索引
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {indexData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-5 flex flex-col items-center text-center gap-2 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-200/60"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
              <span className="text-xs font-bold text-primary-500">{item.count}</span>
              <p className="text-[11px] text-foreground-400 leading-tight">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}